import _t from 'i18n!nls/ai-coach-platform';

/**
 * Returns display labels for the feature name based on the brand update flag.
 * When brand update is enabled, returns generic "This tool" / "this tool" strings
 * instead of the configured brand label (e.g. "Coach").
 *
 * @param isBrandUpdateEnabled - whether the brand update feature flag is active
 * @param defaultLabelIfBrandUpdateDisabled - the configured brand label to use when not brand-updated
 * @returns featureNameLabel (capitalized, for sentence starts) and
 *          featureNameLabelLower (lowercase, for mid-sentence use)
 */
export const getFeatureNameLabels = (
  isBrandUpdateEnabled: boolean,
  defaultLabelIfBrandUpdateDisabled: string
): { featureNameLabel: string; featureNameLabelLower: string } => ({
  featureNameLabel: isBrandUpdateEnabled ? _t('This tool') : defaultLabelIfBrandUpdateDisabled,
  featureNameLabelLower: isBrandUpdateEnabled ? _t('this tool') : defaultLabelIfBrandUpdateDisabled,
});
